import React, { useState } from "react";

/**
 * Watermark used in product photo placeholders.
 * Shows the Ashth logo at low opacity. Falls back to "APS" text if the asset is missing.
 */
export default function PhotoPlaceholder({ size = "lg", className = "" }) {
  const [broken, setBroken] = useState(false);
  const dim = size === "sm" ? "w-12 h-12" : "w-24 h-24";
  if (broken) {
    return (
      <span className={`font-serif text-5xl tracking-[0.25em] text-[#C9A84C]/30 ${className}`}>APS</span>
    );
  }
  return (
    <img
      src="/brand/ashth_logo.png"
      alt=""
      onError={() => setBroken(true)}
      className={`${dim} object-contain opacity-25 ${className}`}
      data-testid="photo-placeholder"
    />
  );
}
